import gql from 'graphql-tag'

export default gql`
mutation DeleteScheduleTask($deleteScheduleTaskId: ID!, $taskType: ScheduleTaskType!) {
  cashAssist {
    deleteScheduleTask(id: $deleteScheduleTaskId, taskType: $taskType) {
      id: taskId
    }
  }
}`
